import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Session } from '../services/auth/session';
import { UNAUTH_HOME_ROUTE } from '../constants/routes';

export const authGuard: CanActivateFn = () => {
  if (inject(Session).getUser()) {
    return true;
  }

  inject(Router).navigate([UNAUTH_HOME_ROUTE]);
  return false;
};
